import { ref, set, get, child } from "firebase/database";
import { useState } from "react";
import Task from "../components/Task";
import {
  GridItem,
  Text,
  Button,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";

function SessionCard({
  id,
  name,
  users,
  usernames,
  userPictures,
  user,
  uid,
  db,
}) {
  const [inCompleteTasks, setInCompleteTasks] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const taskList = {};

  const handleClose = (e) => {
    onClose();
    taskList.length = 0;
  };

  const closeModal = (e) => {
    e.preventDefault();
    onClose();

    if (!(uid in users)) {
      users.push(uid);
      set(ref(db, "sessions/" + id + "/users"), users);
    }
    if (!(user.displayName in usernames)) {
      usernames.push(user.displayName);
      set(ref(db, "sessions/" + id + "/usernames"), usernames);
    }
    if (!(user.photoURL in userPictures)) {
      userPictures.push(user.photoURL);
      set(ref(db, "sessions/" + id + "/userPictures"), userPictures);
    }
    set(
      ref(db, "sessions/" + id + "/tasks/" + uid),
      Object.values(taskList).map((task) => ({
        name: task,
        done: false,
      }))
    );
    set(ref(db, "users/" + uid + "/session"), id);
  };

  const joinSession = async () => {
    console.log("Join session");

    const dbRef = ref(db);
    const snapshot = await get(child(dbRef, `users/${uid}/lastSession`));
    if (snapshot.exists()) {
      console.log("Exists");
      const snapshotTasks = await get(
        child(dbRef, `sessions/${snapshot.val()}/tasks/${uid}`)
      );
      if (snapshotTasks.exists()) {
        console.log("Tasks exist");
        const inCompleteTasks = Object.values(snapshotTasks.val()).filter(
          (task) => !task.done
        );
        if (inCompleteTasks.length > 0) {
          console.log("Incomplete tasks");
          setInCompleteTasks(inCompleteTasks);
          onOpen();
          return;
        }
      }
    }

    if (!(uid in users)) {
      users.push(uid);
      set(ref(db, "sessions/" + id + "/users"), users);
    }
    if (!(user.displayName in usernames)) {
      usernames.push(user.displayName);
      set(ref(db, "sessions/" + id + "/usernames"), usernames);
    }
    if (!(user.photoURL in userPictures)) {
      userPictures.push(user.photoURL);
      set(ref(db, "sessions/" + id + "/userPictures"), userPictures);
    }

    set(ref(db, "users/" + uid + "/session"), id);
  };

  const updateTaskList = (id, val, taskName) => {
    if (val) {
      taskList[id] = taskName;
    } else {
      delete taskList[id];
    }
  };

  return (
    <GridItem borderRadius={10} border="1px" borderColor="gray.400" p={4}>
      <Modal key="a" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Which uncompleted tasks which you like to carry over from the
            previous session?
          </ModalHeader>
          <ModalBody>
            <VStack alignItems="flex-start">
              {inCompleteTasks
                ? inCompleteTasks.map((task, index) => (
                    <Task
                      key={index}
                      id={index}
                      name={task.name}
                      done={false}
                      updateParent={updateTaskList}
                      deleteTask={null}
                    ></Task>
                  ))
                : null}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={closeModal} mr={3}>
              Submit
            </Button>
            <Button onClick={handleClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <VStack alignItems="flex-start">
        <Text fontSize="lg" fontWeight="semibold">
          {name}
        </Text>
        <Text>{users.length} users</Text>
        <Button colorScheme="blue" onClick={joinSession}>
          Join
        </Button>
      </VStack>
    </GridItem>
  );
}

export default SessionCard;
